var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.key)?_c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"now-dot mr-2 adjust",class:_vm.key}),_c('div',{domProps:{"textContent":_vm._s(_vm.opts[_vm.key])}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }